import { initializeColourOverflow, updateColourOverflows, cleanupColourOverflow } from './raith-swatch-overflow.js';
export function registerVLHomeProductEdit(win = window) {
  if (win.customElements.get('vl-home-product-edit')) return;
  class VLHomeProductEdit extends win.HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.controller = new win.AbortController();
      this.cards = new Map();
      for (const card of this.querySelectorAll('.vl-home-card[data-home-product]')) {
        if (card.closest('vl-home-product-edit') !== this) continue;
        const controls = card.querySelector(':scope > [data-home-colours]');
        if (!controls) continue;
        controls.hidden = true;
        const display = card.querySelector(':scope > [data-home-product-content]');
        const status = card.querySelector(':scope > [data-home-colour-status]');
        const templates = [...controls.querySelectorAll(':scope > template[data-home-member]')];
        const choices = [...controls.querySelectorAll(':scope > button[data-home-colour]')];
        const sources = new Map(templates.map(template => [template.dataset.homeMember, template]));
        const ids = choices.map(choice => choice.dataset.homeColour);
        const baseline = card.dataset.homeProduct;
        if (!display || !status || sources.size !== templates.length || choices.length < 2 || new Set(ids).size !== ids.length || !ids.includes(baseline) ||
            sources.size !== ids.length || ids.some(id => !/^[1-9][0-9]*$/.test(id) || !this.panel(sources.get(id), id))) continue;
        const state = {display, status, controls, choices, sources, baseline, selected: display.dataset.homeProductContent};
        this.cards.set(card, state);
        this.select(state, baseline, false);
        controls.hidden = false;
        initializeColourOverflow(state, win, this.controller.signal);
      }
      updateColourOverflows(this.cards.values(), win);
      this.viewportWidth = win.innerWidth;
      const refresh = () => updateColourOverflows(this.cards.values(), win);
      win.document.addEventListener('shopify:section:load', refresh, {signal: this.controller.signal});
      win.document.addEventListener('shopify:section:unload', () => win.requestAnimationFrame(() => { if (this.isConnected) refresh(); }), {signal: this.controller.signal});
      win.addEventListener('resize', () => {
        if (this.viewportWidth === win.innerWidth || this.resizeFrame) return;
        this.resizeFrame = win.requestAnimationFrame(() => {
          this.resizeFrame = null;
          this.viewportWidth = win.innerWidth;
          refresh();
        });
      }, {passive: true, signal: this.controller.signal});
      this.addEventListener('click', event => {
        const choice = event.target.closest('button[data-home-colour]');
        const card = choice?.closest('.vl-home-card');
        const state = this.cards.get(card);
        if (state && state.choices.includes(choice) && choice.parentElement === state.controls && state.controls.parentElement === card) {
          this.select(state, choice.dataset.homeColour, true);
        }
      }, {signal: this.controller.signal});
    }
    panel(template, id) {
      const panel = template?.content?.firstElementChild;
      return template?.content?.children.length === 1 && panel?.dataset.homeProductContent === id ? panel : null;
    }
    select(state, id, announce) {
      const template = state.sources.get(id);
      const source = this.panel(template, id);
      if (!source || template.parentElement !== state.controls) return;
      if (state.selected !== id) {
        const panel = source.cloneNode(true);
        state.display.replaceWith(panel);
        state.display = panel;
        state.selected = id;
        if (announce) state.status.textContent = panel.querySelector('h3')?.textContent || '';
      }
      for (const choice of state.choices) choice.setAttribute('aria-pressed', String(choice.dataset.homeColour === id));
      if (state.more) updateColourOverflows([state], win);
    }
    disconnectedCallback() { this.cleanup(); }
    cleanup() {
      this.controller?.abort();
      if (this.resizeFrame) win.cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = null;
      for (const state of this.cards?.values() || []) {
        cleanupColourOverflow(state);
        this.select(state, state.baseline, false);
        state.status.textContent = '';
        state.controls.hidden = true;
      }
      this.cards = new Map();
    }
  }
  win.customElements.define('vl-home-product-edit', VLHomeProductEdit);
}
if (typeof window !== 'undefined' && window.customElements) registerVLHomeProductEdit(window);
